import script from "./account-main.vue?vue&type=script&lang=ts&setup=true"
export * from "./account-main.vue?vue&type=script&lang=ts&setup=true"

import "./account-main.vue?vue&type=style&index=0&id=3cf72acc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cf72acc"]])

export default __exports__